import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import Navigation from '../layout/Navigation';
import Footer from '../layout/Footer';
import ServiceHero from './ServiceHero';
import ServiceScopeSection from './ServiceScopeSection';
import ServiceAdvantagesSection from './ServiceAdvantagesSection';
import RelatedServices from './RelatedServices';
import {
  homeScrollItem,
  homeScrollViewport,
} from '../../utils/homeScrollMotion';
import styles from './ServiceDetailPage.module.css';

const ServiceDetailPage = ({
  slug,
  icon,
  hue,
  hero,
  title,
  headline,
  summary,
  highlights = [],
  body = [],
  specs = {},
  benefits = [],
  ctaTitle,
  ctaSubtitle,
}) => {
  const deliverables = Object.values(specs);

  return (
    <>
      <Navigation />
      <main className={`${styles.page} site-root`}>
        <ServiceHero
          icon={icon}
          hue={hue}
          hero={hero}
          title={title}
          headline={headline}
          summary={summary}
          highlights={highlights}
        />

        <section className={styles.main} aria-label="Service details">
          <div className={styles.container}>
            <ServiceScopeSection
              hue={hue}
              body={body}
              deliverables={deliverables}
            />

            <ServiceAdvantagesSection hue={hue} benefits={benefits} />

            <motion.div
              className={styles.cta}
              variants={homeScrollItem}
              initial="hidden"
              whileInView="visible"
              viewport={homeScrollViewport}
            >
              <div>
                <h2 className={styles.ctaTitle}>{ctaTitle}</h2>
                <p className={styles.ctaText}>{ctaSubtitle}</p>
              </div>
              <Link to="/contact" className={styles.ctaBtn}>
                Talk to our team
                <ArrowUpRight size={15} strokeWidth={2.5} aria-hidden="true" />
              </Link>
            </motion.div>

            <RelatedServices currentSlug={slug} />
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default ServiceDetailPage;
